import { MenuItem, Text } from '@chakra-ui/react';
import TeamsService from 'api/services/TeamsService';
import Dialog from 'components/Dialog';
import useRedirectURL from 'hooks/useRedirectURL';
import showMessage from 'providers/NoticeProvider/showMessage';
import { useState } from 'react';
import { LuTrash2 } from 'react-icons/lu';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { fetchSingleTeamAgents } from 'store/slices/teams';
import { selectMe } from 'store/slices/user';

type TProps = {
    name: string;
    teamName: string;
    email: string;
    teamId: string;
};

const DeleteMemberDialog = ({ name, teamName, email, teamId }: TProps) => {
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState(false);
    const { company } = useAppSelector(selectMe);

    // TODOD WHAT THIS ?
    const url = useRedirectURL();

    const handleSubmit = async () => {
        setLoading(true);
        // showMessage('The member has been successfully removed from the team.');
        await TeamsService.removeMember({
            email,
            teamId,
            companyId: company.id,
            url,
        })
            .then(() => {
                showMessage('The member has been successfully removed from the team.');
                dispatch(
                    fetchSingleTeamAgents({
                        id: teamId,
                    }),
                );
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <Dialog
            title="Remove from team"
            trigger={
                <MenuItem color="red.500" icon={<LuTrash2 />}>
                    Remove from team
                </MenuItem>
            }
            submitText="Remove from team"
            onSubmit={handleSubmit}
            danger
            loading={loading}
        >
            <div>
                <Text color="gray.500" fontSize="16px" fontWeight={500} lineHeight={1.5} mb="24px">
                    Are you sure you want to remove{' '}
                    <Text color="gray.900" as="span">
                        {name}
                    </Text>{' '}
                    from team{' '}
                    <Text color="gray.900" as="span">
                        {teamName}
                    </Text>
                    ?
                </Text>
                <Text color="red.500" fontSize="16px" fontWeight={500} lineHeight={1.5}>
                    Warning! This action cannot be undone.
                </Text>
            </div>
        </Dialog>
    );
};

export default DeleteMemberDialog;
